import { render } from "./BackgroundImageParallax.vue?vue&type=template&id=0132d35d&scoped=true"
import script from "./BackgroundImageParallax.vue?vue&type=script&lang=js"
export * from "./BackgroundImageParallax.vue?vue&type=script&lang=js"

import "./BackgroundImageParallax.vue?vue&type=style&index=0&id=0132d35d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0132d35d"]])

export default __exports__